<template
    v-if="categoriesStore.topLevelCategories.length > 1"
>
    <div
    class="js-category-filter shrink-0 basis-[100px] flex-col
    items-center text-center h-full"
    >
        <input
            type="checkbox"
            id="showAll"
            class="js-top-level-category inline-block peer sr-only"
            value="showAll"
            v-bind:checked="!categoriesStore.chosenTopLevelCategory"
            v-on:click="categoriesStore.setChosenTopLevelCategory('')"
        >
        <label
            for="showAll"
            class="relative
            peer-focus-visible:ring-4 cursor-pointer
            peer-focus-visible:ring-primary-light/80
            peer-checked:text-primary
            peer-checked:before:block
            peer-checked:before:absolute
            peer-checked:before:w-[80px]
            peer-checked:before:h-[80px]
            peer-checked:before:top-0
            peer-checked:before:left-[calc(50%-40px)]
            peer-checked:before:rounded-[50%]
            peer-checked:before:bg-primary-lightest
            peer-checked:before:z-[-1]"
        >
                <svg class="w-3 h-3 mx-auto mb-qtr text-primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" stroke-width="0" fill="currentColor"><path d="M23.4,5.4c-1.34-2.55-3.91-4.16-6.86-4.32-.35-.02-.71-.02-1.07,0-2.96.16-5.52,1.78-6.86,4.32-1.28,2.43-1.19,5.27.24,7.61l6.82,11.18c.07.12.2.19.34.19s.27-.07.34-.19l6.82-11.18c1.42-2.33,1.51-5.18.24-7.61ZM16,23.2l-6.48-10.62c-1.28-2.09-1.36-4.64-.21-6.82,1.21-2.29,3.52-3.75,6.2-3.9.16,0,.33-.01.49-.01s.33,0,.49.01c2.67.15,4.99,1.6,6.2,3.9,1.14,2.18,1.07,4.72-.21,6.82l-6.48,10.62Z" style="stroke-width:0px;"/><path d="M16,4.76c-.76,0-1.52.19-2.19.54-.2.1-.27.34-.17.54.1.2.34.27.54.17.55-.29,1.18-.45,1.81-.45,2.14,0,3.89,1.74,3.89,3.88s-1.74,3.89-3.89,3.89-3.89-1.74-3.89-3.89c0-.77.22-1.51.65-2.14.12-.18.07-.43-.11-.55-.18-.12-.43-.07-.55.11-.51.77-.78,1.66-.78,2.59,0,2.58,2.1,4.69,4.69,4.69s4.69-2.1,4.69-4.69-2.1-4.69-4.69-4.69Z" style="stroke-width:0px;"/><path d="M26.7,30.94c.14,0,.27-.07.34-.19l3.98-6.52c.86-1.41.92-3.13.14-4.6-.81-1.54-2.36-2.51-4.14-2.61-.21-.01-.43-.01-.64,0-1.79.1-3.33,1.07-4.14,2.61-.77,1.47-.72,3.19.14,4.6l3.98,6.52c.07.12.2.19.34.19ZM22.95,19.99c.68-1.29,1.98-2.1,3.48-2.19.09,0,.18,0,.28,0s.19,0,.28,0c1.5.08,2.8.9,3.48,2.19.64,1.22.6,2.64-.12,3.82l-3.64,5.96-3.64-5.96c-.71-1.17-.76-2.6-.12-3.82Z" style="stroke-width:0px;"/><path d="M29.39,22.06c0-1.48-1.2-2.68-2.68-2.68-.2,0-.39.02-.59.07-.22.05-.35.26-.3.48.05.21.26.34.48.3,1.17-.27,2.3.66,2.3,1.84,0,1.04-.84,1.88-1.88,1.88s-1.88-.84-1.88-1.88c0-.3.07-.58.2-.84.1-.2.02-.44-.18-.54-.2-.1-.44-.02-.54.18-.19.38-.28.78-.28,1.2,0,1.48,1.2,2.68,2.68,2.68s2.68-1.2,2.68-2.68Z" style="stroke-width:0px;"/><path d="M7.16,20.68c-.2.1-.28.34-.18.54.13.26.2.55.2.84,0,1.04-.84,1.88-1.88,1.88s-1.88-.84-1.88-1.88c0-1.18,1.12-2.1,2.3-1.84.22.04.43-.09.48-.3.05-.22-.09-.43-.3-.48-.19-.04-.39-.07-.59-.07-1.48,0-2.68,1.2-2.68,2.68s1.2,2.68,2.68,2.68,2.68-1.2,2.68-2.68c0-.42-.1-.83-.28-1.2-.1-.2-.34-.28-.54-.18Z" style="stroke-width:0px;"/><path d="M9.76,19.62c-.81-1.54-2.36-2.52-4.14-2.61-.21-.01-.43-.01-.64,0-1.79.1-3.33,1.07-4.14,2.61-.77,1.47-.72,3.19.14,4.6l3.98,6.52c.07.12.2.19.34.19s.27-.07.34-.19l3.98-6.52c.86-1.41.92-3.13.14-4.6ZM8.94,23.81l-3.64,5.96-3.64-5.96c-.71-1.17-.76-2.6-.12-3.82.68-1.29,1.98-2.1,3.48-2.19.09,0,.18,0,.28,0s.18,0,.28,0c1.5.08,2.8.9,3.48,2.19.64,1.22.6,2.64-.12,3.82Z" style="stroke-width:0px;"/></svg>
            Show All
        </label>
    </div>
    <template v-for="category in categoriesStore.topLevelCategories">
        <div
            v-if="category"
            class="js-category-filter shrink-0 basis-[100px] flex-col
            items-center text-center h-full"
        >
            <input
                type="checkbox"
                v-bind:id="category.id"
                class="js-top-level-category peer sr-only"
                v-bind:value="category.id"
                v-bind:checked="parseInt(categoriesStore.chosenTopLevelCategory) === parseInt(category.id)"
                v-on:click="topLevelCategoryClick"
            >
            <label
                v-bind:for="category.id"
                v-bind:title="category.title"
                class="relative
                peer-focus-visible:ring-4 cursor-pointer
                peer-focus-visible:ring-primary-light/80
                peer-checked:text-primary
                peer-checked:before:block
                peer-checked:before:absolute
                peer-checked:before:w-[80px]
                peer-checked:before:h-[80px]
                peer-checked:before:top-0
                peer-checked:before:left-[calc(50%-40px)]
                peer-checked:before:rounded-[50%]
                peer-checked:before:bg-primary-lightest
                peer-checked:before:z-[-1]"
            >
                <IconRenderer :svg="category.filterIconSvg.replace('w-[30px] h-[30px]', 'w-3 h-3')" v-if="category.filterIconSvg" />
                <img
                    class="w-3 h-3 mx-auto mb-qtr"
                    v-else
                    src="../../assets/no-image-1x1.png"
                    loading="lazy"
                    alt=""
                />
                {{category.title}}
            </label>
        </div>
    </template>
</template>
